import Swal from "sweetalert2";

const normalizeOptions = (options) => {
  const normalized = { ...options };

  if ("closeOnClickOutside" in normalized) {
    normalized.allowOutsideClick = normalized.closeOnClickOutside;
    delete normalized.closeOnClickOutside;
  }

  if ("buttons" in normalized) {
    normalized.showCancelButton = Boolean(normalized.buttons);
    delete normalized.buttons;
  }

  if ("button" in normalized) {
    if (normalized.button === false) {
      normalized.showConfirmButton = false;
    } else if (typeof normalized.button === "string") {
      normalized.confirmButtonText = normalized.button;
    }
    delete normalized.button;
  }

  if (normalized.dangerMode) {
    normalized.confirmButtonColor = "#d33";
    delete normalized.dangerMode;
  }

  return normalized;
};

export const installLegacySwal = () => {
  window.Swal = Swal;
  window.swal = (titleOrOptions, text, icon) => {
    const options =
      typeof titleOrOptions === "object"
        ? normalizeOptions(titleOrOptions)
        : { title: titleOrOptions, text, icon };

    return Swal.fire(options).then((result) => result.isConfirmed);
  };
};
